import { Link } from 'react-router-dom';

interface Business {
  id: number;
  name: string;
  category: string;
  categoryName: string;
  address: string;
  phone: string;
  contact: string;
  email: string;
  website: string;
  description: string;
  tags: string[];
  rating: number;
  reviewCount: number;
  verified: boolean;
  imageSeq: string;
  featured: boolean;
}

interface BusinessCardProps {
  business: Business;
}

export default function BusinessCard({ business }: BusinessCardProps) {
  return (
    <article
      className="bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-200 transition-all duration-300"
      data-product-shop=""
    >
      <div className="flex items-start gap-4">
        <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-background-100 flex items-center justify-center">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-building-2-line text-2xl text-primary-500"></i>
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="text-base font-semibold text-foreground-900 truncate">
              {business.name}
            </h3>
            {business.verified && (
              <span className="inline-flex items-center gap-0.5 text-xs text-accent-600 bg-accent-50 px-1.5 py-0.5 rounded whitespace-nowrap">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-verified-badge-fill text-xs"></i>
                </div>
                已认证
              </span>
            )}
          </div>
          <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-map-pin-line text-xs"></i>
            </div>
            <span className="truncate">{business.address}</span>
          </div>
          <div className="flex items-center gap-1 mt-1.5">
            {[1, 2, 3, 4, 5].map((star) => (
              <div key={star} className="w-3.5 h-3.5 flex items-center justify-center">
                <i
                  className={`${
                    star <= Math.round(business.rating) ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'
                  } text-xs`}
                ></i>
              </div>
            ))}
            <span className="text-xs text-foreground-500 ml-1">
              {business.rating} ({business.reviewCount}条评价)
            </span>
          </div>
        </div>
      </div>

      <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-2">
        {business.description}
      </p>

      <div className="mt-3 flex flex-wrap gap-1.5">
        {business.tags.slice(0, 3).map((tag) => (
          <span
            key={tag}
            className="text-xs text-secondary-700 bg-secondary-50 px-2 py-0.5 rounded whitespace-nowrap"
          >
            {tag}
          </span>
        ))}
      </div>

      <div className="mt-4 flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
        <span className="flex items-center gap-1">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-phone-line text-xs"></i>
          </div>
          {business.phone}
        </span>
        <Link
          to={`/category/${business.category}`}
          className="flex items-center gap-1 text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
        >
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-folder-line text-xs"></i>
          </div>
          {business.categoryName}
        </Link>
      </div>
    </article>
  );
}